module.exports = __webpack_public_path__ + "static/img/2.ed64653.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/sp/2.png
// module id = ZGKd
// module chunks = 0